import { useCallback } from "react";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import * as UseCase from "../../model/use-case";

import type { PaymentDepositAccountFormModel } from "../../model/type";

type Props = {
	viewModel: PaymentDepositAccountFormModel["ViewModel"];
	onResetViewModel: () => void;
};
export const useUpdatePaymentDepositAccount = ({ viewModel, onResetViewModel }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { onUpdatePaymentDepositAccount: _onUpdatePaymentDepositAccount } = UseCase.useUpdatePaymentDepositAccount({
		viewModel,
	});
	const onUpdatePaymentDepositAccount = useCallback(async () => {
		showLoadingScreenCallback();

		const { errors } = await _onUpdatePaymentDepositAccount().finally(hideLoadingScreenCallback);

		if (!errors) {
			notifyUserEventInfo({
				title: "入金先情報の設定を更新しました",
			});
			onResetViewModel();
		}
	}, [_onUpdatePaymentDepositAccount, hideLoadingScreenCallback, onResetViewModel, showLoadingScreenCallback]);

	return { onUpdatePaymentDepositAccount };
};
